import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Wed Aug 08 2018
 * @author SKu
 */
import ModalStyled from './styled/ModalStyled';
import { Key } from '../../../shared/keyboard/Key';
import * as React from 'react';
import ReactDOM from 'react-dom';
import Icon, { IconType, IconColor } from '../../media/Icon';

var Modal =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Modal, _React$PureComponent);

  function Modal() {
    var _this;

    _classCallCheck(this, Modal);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Modal).apply(this, arguments));
    _this.doubleClickEsc = false;
    /**
     * Function closes  modal on ESCAPE
     */

    _this.closeOnEsc = function (e) {
      if (e.key === Key.Escape) {
        // LOG-5561
        if (_this.doubleClickEsc) {
          e.preventDefault();

          _this.unSubscribe();

          _this.props.close();
        }

        _this.doubleClickEsc = true;
        setTimeout(function () {
          return _this.doubleClickEsc = false;
        }, 300);
      }
    };

    _this.handleKeyUp = function (e) {
      _this.closeOnEsc(e);

      if (_this.props.handleKeyUp !== undefined) {
        _this.props.handleKeyUp(e);
      }
    };
    /**
     *   add listener for detection ESCAPE
     */


    _this.subscribe = function () {
      window.addEventListener('keyup', _this.handleKeyUp, false);
    };
    /**
     * remove listener
     */


    _this.unSubscribe = function () {
      window.removeEventListener('keyup', _this.handleKeyUp, false);
    };
    /**
     * Function closes modal on click
     */


    _this.handleCloseOnClick = function () {
      _this.unSubscribe();

      _this.props.close();
    };
    /**
     * Function prevents modal from closing, when click is on it
     */


    _this.handleInnerCloseOnClick = function (e) {
      e.stopPropagation();
    };

    return _this;
  }

  _createClass(Modal, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unSubscribe();
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.hidden) {
        this.unSubscribe();
      } else if (nextProps.close) {
        this.subscribe();
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.hidden ? null : React.createElement(ModalWindow, Object.assign({}, this.props, {
        handleCloseOnClick: this.handleCloseOnClick,
        handleInnerCloseOnClick: this.handleInnerCloseOnClick
      }), this.props.children);
    }
  }]);

  return Modal;
}(React.PureComponent);
/**
 * Create Modal component. Component creates modal box, that renders context from children
 */


var ModalWindow =
/*#__PURE__*/
function (_React$PureComponent2) {
  _inherits(ModalWindow, _React$PureComponent2);

  function ModalWindow() {
    var _this2;

    _classCallCheck(this, ModalWindow);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(ModalWindow).apply(this, arguments));
    /** Elements for modal root rendering */

    _this2.modalRoot = document.getElementById('root');
    _this2.rootElement = document.createElement('div');
    return _this2;
  }

  _createClass(ModalWindow, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.modalRoot.appendChild(this.rootElement);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.modalRoot.removeChild(this.rootElement);
    }
  }, {
    key: "render",
    value: function render() {
      return ReactDOM.createPortal(React.createElement(React.Fragment, null, React.createElement(ModalStyled, Object.assign({}, this.props, {
        title: "",
        onClick: this.props.close && this.props.handleCloseOnClick
      }), React.createElement("div", {
        id: "testModal",
        className: "modal",
        onClick: this.props.handleInnerCloseOnClick
      }, React.createElement("div", {
        className: "modal-header"
      }, React.createElement("h3", null, this.props.title), this.props.close && React.createElement("button", {
        onClick: this.props.handleCloseOnClick,
        className: "modal-close "
      }, React.createElement(Icon, {
        iconType: IconType.cancel,
        iconColor: IconColor.Inverse,
        iconHeight: 23
      }))), React.createElement("div", {
        className: "modal-content"
      }, this.props.children)))), this.rootElement);
    }
  }]);

  return ModalWindow;
}(React.PureComponent);

export default Modal;